import React,{Component} from "react";
import { Layout} from 'antd';
import Header from "../../components/header";
import './cover.less'
import {reqUserPaper} from "../../api";
const {Content } = Layout;

export default class Cover extends Component {

    state = {
        mock:'#12c4ed',
        exam:'#ccc',
        status:'mock',
        btnText:'开始',
        beginColor:'#12c4ed'
    };

    TestTab = async (type) => {
        if (type === 'mock') {
            const result = await reqUserPaper("MOCK");
            if(result.data.total>0){
                sessionStorage.setItem("paperNo",result.data.rows[0].testPaperNo);
            }else {
                sessionStorage.setItem("paperNo","none");
            }
            this.setState({
                mock: '#12c4ed',
                exam: '#ccc',
                status: 'mock',
                btnText: '开始',
                beginColor: '#12c4ed'
            });
            sessionStorage.setItem("pid","mock");
            document.getElementById("begin").disabled = false;
        } else {
            const result = await reqUserPaper("FORMAL");
            if(result.data.total>0){
                this.setState({
                    mock: '#ccc',
                    exam: '#12c4ed',
                    status: 'exam',
                    btnText: '开始',
                    beginColor: '#12c4ed'
                });
                sessionStorage.setItem("pid","formal");
                sessionStorage.setItem("paperNo",result.data.rows[0].testPaperNo);
                document.getElementById("begin").disabled = false;
            }else {
                this.setState({
                    mock: '#ccc',
                    exam: '#12c4ed',
                    status: 'exam',
                    btnText: '无考试',
                    beginColor: '#ccc'
                });
                document.getElementById("begin").disabled = true;
            }
        }
    };

    beginTest= async () => {
        this.props.history.replace("/exam");
    };

    componentDidMount = async () => {
        sessionStorage.clear();
        this.TestTab("mock");
    };

    render() {
        return (
            <Layout>
                <Header>Header</Header>
                <Content className='cover'>
                    <div className='cover_main'>
                        <div className='cover_center'>
                            <div className='cover_top'>
                                <img src={require('./images/examination-header-img1.png')}/>
                                <h3 className='cover_title'>考前必读:</h3>
                                <div>1.模拟考试为日常练习模块，正式考试<span style={{color:"#e20101"}}>为教师发布考试模块。</span></div>
                                <div>2.如果你已经准备好了，就点击“开始考试“按钮即进入考场，开始计时。</div>
                                <div>3.题目右侧图片点击可放大查看。</div>
                                <div>4.考试过程中会在试卷的左侧显示倒计时，您可以查看考试剩余时间。</div>
                                <div>5.当完成试卷后，可以点击“交卷“按钮提交试卷。</div>
                                <div style={{color:"#e20101"}}>6.重要提示：教师发布的试卷考试过程中，如果离开试题页面两次，试卷会自动提交。</div>
                                <div style={{color:"#e20101",marginLeft:102}}>(切换页面和缩小考试页面都按离开页面处理!!!) </div>
                                <div style={{color:"#e20101",marginLeft:103}}>交卷后将无法继续参加考试!!! </div>
                            </div>
                            <div className='cover_body'>
                                <h3>选择考试模块：</h3>
                                <div className='cover_choice'>
                                    <button id='mock' className='cover_btn' onClick={this.TestTab.bind(this,'mock')} style={{background:this.state.mock}}>模拟考试</button>
                                    <button id='exam' className='cover_btn' onClick={this.TestTab.bind(this,'exam')} style={{background:this.state.exam}}>正式考试</button>
                                </div>
                                <div className='cover_begin'>
                                    <button id='begin' style={{background:this.state.beginColor}} onClick={this.beginTest.bind(this)}>{this.state.btnText}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Content>
            </Layout>
        )
    }
}



